"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTree = void 0;
var TriStateCheckbox_1 = require("../../components/TriStateCheckbox");
var R = __importStar(require("../../utils/ramda"));
var react_1 = require("react");
var treeOptionDefaults = {
  initialSelection: [],
  initialExpansion: [],
  initialFilteredOut: []
};
var useTree = function (selector, initializers) {
  var _a = R.mergeRight(treeOptionDefaults, initializers !== null && initializers !== void 0 ? initializers : {}),
    initialSelection = _a.initialSelection,
    initialExpansion = _a.initialExpansion,
    initialFilteredOut = _a.initialFilteredOut;
  var _b = __read((0, react_1.useState)(selector.createMap(R.always(TriStateCheckbox_1.TriState.Empty))), 2),
    _selected = _b[0],
    setSelected = _b[1];
  var _c = __read((0, react_1.useState)(selector.createMap(function (id) {
      return initialExpansion.includes(id);
    })), 2),
    _expanded = _c[0],
    setExpanded = _c[1];
  var _d = __read((0, react_1.useState)(selector.createMap(function (id) {
      return initialFilteredOut.includes(id);
    })), 2),
    _filteredOut = _d[0],
    setFilteredOut = _d[1];
  var select = function (id, state) {
    return setSelected(selector.select(id, state, _selected));
  };
  var expand = function (id, expanded) {
    return setExpanded(R.assoc(id.toString(), expanded, _expanded));
  };
  var onSelectionToggle = function (id) {
    return setSelected(selector.toggle(id, _selected));
  };
  var onExpansionToggle = function (id) {
    return setExpanded(R.assoc(id.toString(), !_expanded[id], _expanded));
  };
  (0, react_1.useEffect)(function () {
    setSelected(selector.listSelection(initialSelection));
  }, []);
  return {
    selected: _selected,
    expanded: _expanded,
    filterOut: _filteredOut,
    select: select,
    expand: expand,
    onSelectionToggle: onSelectionToggle,
    onExpansionToggle: onExpansionToggle,
    setFilteredOut: setFilteredOut,
    setSelected: setSelected,
    setExpanded: setExpanded,
    treeStructure: selector,
    selector: selector
  };
};
exports.useTree = useTree;